import { Language } from "@/shared/types/type/language"
import { TermModalType } from "@/shared/types/type/terms"
import { create } from "zustand"

export interface Toast {
  type: "success" | "error" | "info" | "warning"
  message: string
}

interface UIStore {
  language: Language
  setLanguage: (language: Language) => void
  isTermModalOpen: boolean
  termModalType: TermModalType | ''
  setIsTermModalOpen: (isTermModalOpen: boolean, termModalType: TermModalType) => void
  toast: Toast | null
  showToast: (type: Toast["type"], message: string) => void
}

const useUIStore = create<UIStore>((set) => ({
  language: "ko",
  setLanguage: (language: Language) => set({ language }),
  isTermModalOpen: false,
  termModalType: "",
  setIsTermModalOpen: (isTermModalOpen: boolean, termModalType: TermModalType) => set({ isTermModalOpen, termModalType }),
  toast: null,
  showToast: (type: Toast["type"], message: string) => {
    set({ toast: { type, message } })
    setTimeout(() => {
      set({ toast: null })
    }, 1800)
  },
}))

export default useUIStore
